import request from '@/utils/request'

// 仓库类型下拉选项
export function getWarehouseTypeOptions() {
    return request({
        url: '/common/dict/options/GoodsWarehouseType',
        method: 'get',
    })
}
